import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import PaperDraggable from "../../../../../../../components/PaperDraggable"
import { TTitulosCnab240 } from "../../../../../../../types/api/financeiro/detalhar-integracao-bancaria";
import DisplayNotFoundInfo from "../../../../../../../components/DisplayNotFindInfo";
import moment from "moment";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import { DadoValorPrinter } from "../../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";

export default function DialogAnalisarTitulosCnab240({
    open,
    opcoes,
    totais,
    handleClose,
}: DialogAnalisarTitulosCnab240Props) {
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="body"
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Analisar Títulos CNAB 240</DialogTitle>

                <DialogContent>
                    <Box py={1}>
                        <Stack spacing={4} direction={'row'}>
                            <DadoValorPrinter titulo="Títulos na cobrança:" valor={`${totais.total_cobrancas}`} />
                            <DadoValorPrinter titulo="Títulos encontrados:" valor={`${totais.total_possiveis}`} />
                        </Stack>
                        {
                            opcoes.length === 0 && (
                                <Typography>
                                    <DisplayNotFoundInfo label="Nenhum título encontrado" />
                                </Typography>
                            )
                        }
                        {opcoes.length > 0 && (
                            <TableContainer
                                sx={{ height: 400, overflow: "auto", mb: 1 }}
                            >
                                <Table size="small" aria-label="a dense table" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <b>Título</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Emissão</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Vencimento</b>
                                            </TableCell>
                                            <TableCell align="right">
                                                <b>Valor</b>
                                            </TableCell>
                                            <TableCell align="right">
                                                <b>Saldo principal</b>
                                            </TableCell>
                                            <TableCell align="right">
                                                <b>Saldo atualizado</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Situação</b>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {opcoes.map((row) => {
                                            return (
                                                <TableRow
                                                    key={row.identificacao}
                                                    sx={{
                                                        "&:last-child td, &:last-child th": { border: 0 },
                                                    }}
                                                >
                                                    <TableCell>{row.identificacao}</TableCell>
                                                    <TableCell>
                                                        {moment(row.data_emissao).format("DD/MM/YYYY")}
                                                    </TableCell>
                                                    <TableCell>{moment(row.data_vencimento).format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell align="right">{formatarValorMonetario(row.valor_receber)}</TableCell>
                                                    <TableCell align="right">{formatarValorMonetario(row.saldo_principal)}</TableCell>
                                                    <TableCell align="right">{formatarValorMonetario(row.saldo_simulado)}</TableCell>
                                                    <TableCell>{row.situacao}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button
                        autoFocus
                        variant="outlined"
                        onClick={handleClose}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

interface DialogAnalisarTitulosCnab240Props {
    open: boolean;
    opcoes: TTitulosCnab240[];
    totais: {
        total_cobrancas: number;
        total_possiveis: number;
    }
    handleClose: () => void;
}
